import React, {useState} from 'react'
import classNames from 'classnames'
import {observer} from 'mobx-react'
import {Col, Row, Typography} from 'antd'
import {useTranslation} from 'react-i18next'
import {Modal} from '@/components'
import {CookiesLinks, CookiesAccept, IndividualCookie} from './components'
import {CookiesModalProps} from './props'
import styles from './styles.scss'

export const Cookies: React.FC<CookiesModalProps> = observer(
    ({
        open,
        statisticsChecked,
        setStatisticsChecked,
        onSaveClick,
        onEssentialClick,
        onAllAcceptClick
    }) => {
        const {t} = useTranslation()
        const [type, setType] = useState<'all' | 'individual' | 'essential'>('all')

        const isAll = type === 'all'

        return (
            <Modal
                className={classNames(styles.modal, {
                    [styles.all]: isAll
                })}
                open={open}
                closable={false}
                title={null}
                footer={null}
            >
                {isAll && (
                    <Row gutter={[40, 40]} justify={'space-between'}>
                        <Col span={16} xs={24} md={16}>
                            <Typography.Title level={3}>{t('Cookies.cookies')}</Typography.Title>
                            <Typography.Text>{t('Cookies.cookiesContent')}</Typography.Text>

                            <CookiesLinks className={styles.links} />
                        </Col>
                        <Col span={8} xs={24} md={8}>
                            <CookiesAccept
                                onAllClick={onAllAcceptClick}
                                onEssentialClick={onEssentialClick}
                                onIndividualClick={() => {
                                    setType('individual')
                                }}
                            />
                        </Col>
                    </Row>
                )}
                {type === 'individual' && (
                    <IndividualCookie
                        statisticsChecked={statisticsChecked}
                        onSaveClick={onSaveClick}
                        setStatisticsChecked={setStatisticsChecked}
                        onBackClick={() => setType('all')}
                        onAcceptAllClick={() => {
                            setType('all')
                            onAllAcceptClick()
                        }}
                    />
                )}
            </Modal>
        )
    }
)
